import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

export default function FeedbackModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} centered={true} toggle={onClose}>
      <ModalHeader toggle={onClose}>Feedback</ModalHeader>
      <ModalBody>
        <form
          onSubmit={e => {
            e.preventDefault();
            const name = e.target.elements.feedbackName.value.trim();
            const email = e.target.elements.feedbackEmail.value.trim();
            const feedback = e.target.elements.feedbackText.value.trim();
            if (!name || !email || !feedback) {
              alert('Please fill out all fields.');
              return;
            }
            // Compose mailto link
            const subject = encodeURIComponent('INSTRUCT App Feedback');
            const body = encodeURIComponent(
              `Name: ${name}\nEmail: ${email}\n\nFeedback:\n${feedback}`
            );
            window.open(`mailto:admin@instruct.aac-learning-center.org?subject=${subject}&body=${body}`);
            onClose();
          }}
        >
          <div className="form-group mb-2">
            <label>
              Thank you for your feedback!
              <br /><br />
              Clicking submit should open a new email window with a pre-filled subject and body. If it does not, please send your feedback to <span style={{fontStyle: 'italic'}}>admin@instruct.aac-learning-center.org</span>
            </label>
          </div>
          <div className="form-group mb-2">
            <label htmlFor="feedbackName">Name<span style={{color:'red'}}>*</span></label>
            <input type="text" className="form-control" id="feedbackName" name="feedbackName" required />
          </div>
          <div className="form-group mb-2">
            <label htmlFor="feedbackEmail">Email<span style={{color:'red'}}>*</span></label>
            <input type="email" className="form-control" id="feedbackEmail" name="feedbackEmail" required />
          </div>
          <div className="form-group mb-2">
            <label htmlFor="feedbackText">Feedback<span style={{color:'red'}}>*</span></label>
            <textarea className="form-control" id="feedbackText" name="feedbackText" rows="4" required></textarea>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">Send Feedback</button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
